import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import { Alert, Form, FormGroup, FormControl, Button } from 'react-bootstrap';

function LoginForm() {

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState();
  const history = useHistory();

  const handleSubmit = (evt) => {
    evt.preventDefault();
    let userdata = { username: username, password: password };

    fetch('/login', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(userdata),
    })
    .then(response => {
      if (response.ok) history.push('/console');
      else return response.json();
    })
    .then(error => {
      if (error.error === 'connection_failed') setErrorMessage("Connection failed");
      else setErrorMessage("Invalid username/password");
    })
    .catch(error => {
        setErrorMessage("Login error");
    });
  }

  return (
    <Form id="loginForm">
      <div className="illustration"><i className="icon ion-ios-navigate"></i></div>
      <FormGroup controlId="username">
        <FormControl type="email" placeholder="Email Address" value={username} onChange={e => setUsername(e.target.value)} />
      </FormGroup>
      <FormGroup controlId="current-pasword">
        <FormControl type="password" placeholder="Password" autoComplete="on" value={password} onChange={e => setPassword(e.target.value)} />
      </FormGroup>
      <FormGroup controlId="formSubmit">
        <Button className="btn btn-primary btn-block" type="submit" onClick={handleSubmit}>
          Login
        </Button>
      </FormGroup>
      { errorMessage && <Alert variant="danger">{errorMessage}</Alert> }
    </Form>
  )
}

export default LoginForm;
